<template>
  <a-layout-sider
    class="layout-sider"
    :trigger="null"
    collapsible
    v-model="collapsed"
  >
    <div class="logo-container" @click="backHome">
      <img src="../../assets/images/logo_white.png" alt="logo" />
    </div>

    <a-menu
      theme="dark"
      mode="inline"
      :defaultSelectedKeys="['1']"
      :defaultOpenKeys="defaultOpenKeys"
      :selectedKeys="selectedKeys"
    >
      <a-menu-item key="index">
        <router-link to="/">
          <a-icon type="dashboard" />
          <span>Dashborad</span>
        </router-link>
      </a-menu-item>

      <a-sub-menu key="home">
        <span slot="title"> <a-icon type="home" /><span>主页管理</span> </span>
        <a-menu-item key="lang">
          <router-link to="/home">主页内容</router-link>
        </a-menu-item>
        <a-menu-item key="banner">
          <router-link to="/banner">主页Banner</router-link>
        </a-menu-item>
      </a-sub-menu>

      <a-sub-menu key="product">
        <span slot="title">
          <a-icon type="barcode" /><span>产品管理</span>
        </span>
        <a-menu-item key="product-type">
          <router-link to="/product-type">产品分类</router-link>
        </a-menu-item>
        <a-menu-item key="product-info">
          <router-link to="/product">产品信息</router-link>
        </a-menu-item>
        <a-menu-item key="product-menu">
          <router-link to="/product-menu">产品菜单</router-link>
        </a-menu-item>
      </a-sub-menu>

      <a-sub-menu key="news">
        <span slot="title">
          <a-icon type="calendar" /><span>新闻管理</span>
        </span>
        <a-menu-item key="news-type">
          <router-link to="/news-type">新闻分类</router-link>
        </a-menu-item>
        <a-menu-item key="news-content">
          <router-link to="/news">新闻内容</router-link>
        </a-menu-item>
      </a-sub-menu>

      <a-menu-item key="artist">
        <router-link to="/artist">
          <a-icon type="team" />
          <span>艺人管理</span>
        </router-link>
      </a-menu-item>

      <a-sub-menu key="support">
        <span slot="title">
          <a-icon type="question-circle" /><span>支持管理</span>
        </span>
        <a-menu-item key="support-type">
          <router-link to="/support-type">支持分类</router-link>
        </a-menu-item>
        <a-menu-item key="support-content">
          <router-link to="/support">支持内容</router-link>
        </a-menu-item>
        <a-menu-item key="support-faq">
          <router-link to="/faq">FAQ</router-link>
        </a-menu-item>
      </a-sub-menu>

      <a-menu-item key="distributor">
        <router-link to="/distributor">
          <a-icon type="shop" />
          <span>经销商（国外）</span>
        </router-link>
      </a-menu-item>

      <a-menu-item key="distributor-cn">
        <router-link to="/distributorCN">
          <a-icon type="shop" />
          <span>经销商（国内）</span>
        </router-link>
      </a-menu-item>

      <a-menu-item key="about">
        <router-link to="/about">
          <a-icon type="message" />
          <span>关于管理</span>
        </router-link>
      </a-menu-item>
    </a-menu>
  </a-layout-sider>
</template>

<script>
export default {
  name: 'Sider',

  computed: {
    collapsed() {
      return this.$store.state.layout.collapsed
    },
    selectedKeys() {
      return [this.$route.meta.menuSelectedKey]
    },
    defaultOpenKeys() {
      const menuSelectedKey = this.$route.meta.menuSelectedKey
      if (
        menuSelectedKey === 'news-type' ||
        menuSelectedKey === 'news-content'
      ) {
        return ['news']
      } else if (
        menuSelectedKey === 'product-type' ||
        menuSelectedKey === 'product-info' ||
        menuSelectedKey === 'product-menu'
      ) {
        return ['product']
      } else if (
        menuSelectedKey === 'support-type' ||
        menuSelectedKey === 'support-content'
      ) {
        return ['support']
      } else {
        return []
      }
    }
  },

  methods: {
    backHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-sider {
  z-index: 100;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
}

.logo-container {
  height: 32px;
  margin: 16px;
  text-align: center;
  line-height: 32px;
  cursor: pointer;

  img {
    width: 90%;
  }
}
</style>
